import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { Container } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { isFullScreen, myTheme } from '../hooks/useThemeMode';

const Layout = () => {
  const [showGoTop, setShowGoTop] = useState(false);
  // const theme: any = useTheme();

  useEffect(() => {
    const handleScroll = () => {
      setShowGoTop(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  // const screenWidth = isMobile ? theme1.maxWidth.sm : theme1.maxWidth.xxl;

  return (
    <>
      <Container
        className={myTheme}
        // maxWidth={isFullScreen ? 'xl' : 'lg'}
        maxWidth={false}
        sx={{
          // maxWidth: 'var(--container-max-width)',
          paddingLeft: '0 !important',
          paddingRight: '0 !important',
        }}
        // sx={{ paddingLeft: '0 !important', paddingRight: '0 !important' }}
      >
        {showGoTop && (
          <div className='goTopContainer' onClick={scrollToTop}>
            <KeyboardArrowUpIcon fontSize='large' />
          </div>
        )}
        <Header />
        <main
          style={{
            // padding: isFullScreen ? '0' : '20px',
            marginTop: isFullScreen ? 0 : '85px',
          }}
        >
          <Outlet />
        </main>
        <Footer />
      </Container>
    </>
  );
};

export default Layout;
